import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";

// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getMessageList, getMessageCount } from "~/redux/actions/message";

// view
import { Alert, Card, Menu, Badge, Space } from "antd";
import SiteLayout from "~/components/layout/SiteLayout";
import NewPostCard from "~/components/sider/NewPostCard";
import SkeletonList from "~/components/app/SkeletonList";
import Pager from "~/components/site/Pager";
import Message from "~/components/message/Message";
import settings from "~/settings";

// utils
import _ from "lodash";
import { hasAnyRole } from "~/utils/user";

const Page = (props) => {
  // hooks
  const router = useRouter();
  const { page = 1, category = "content" } = router.query;
  const [state, setState] = useState({ category });
  const [loading, setLoading] = useState(false);

  // props
  const { token, messageList, messageCount } = props;
  const { messages, pager } = messageList || {};
  // const isContributorOrAdmin = hasAnyRole(props.user, ["admin", "contributor"]);

  // handles
  const handleFetch = (page) => {
    setLoading(true);
    props.getMessageList(token, { page, category: state.category }, () => {
      setLoading(false);
    });
    router.push(`/messages?page=${page}`, { shallow: true });
  };
  const handleCategoryChange = ({ key }) => {
    setState({ category: key });
  };

  // views
  const pageSider = (
    <div>
      <NewPostCard />
    </div>
  );
  const renderMessage = (message) => {
    const messageType = _.upperFirst(_.camelCase(message.kind));
    const MessageItem = Message[messageType];
    return MessageItem ? (
      <MessageItem
        key={message.id}
        message={message}
      />
    ) : (
      <pre
        key={message.id}
        className="debug"
      >
        {JSON.stringify(message, null, 2)}
      </pre>
    );
  };

  const renderEmptyDescription = () => {
    if (state.category === "talent") {
      return (
        <div>
          暂无数据，
          <Link
            className="primary-link"
            href={`${settings.talentUrl}/me/profile`}
          >
            提交简历
          </Link>
          加入电鸭人才库
        </div>
      );
    } else if (state.category === "jobs_channel") {
      return (
        <div>
          暂无数据，前往
          <Link
            className="primary-link"
            href="/jobs-channel"
          >
            职位频道
          </Link>
          申请优质岗位
        </div>
      );
    }
    return "暂无消息";
  };

  // events
  useEffect(() => handleFetch(page), []);
  useEffect(() => handleFetch(1), [state.category]);

  return (
    <SiteLayout
      pageTitle="我的消息"
      pageSider={pageSider}
    >
      <Card>
        <Space
          direction="vertical"
          style={{ display: "flex" }}
        >
          <Menu
            mode="horizontal"
            selectedKeys={[state.category]}
            onSelect={handleCategoryChange}
          >
            <Menu.Item key="content">
              <Badge dot={messageCount.category.content > 0}>留言与回复</Badge>
            </Menu.Item>
            <Menu.Item key="charge">
              <Badge dot={messageCount.category.charge > 0}>电量提示</Badge>
            </Menu.Item>
            <Menu.Item key="profile">
              <Badge dot={messageCount.category.profile > 0}>谁看过我</Badge>
            </Menu.Item>
            <Menu.Item key="system">
              <Badge dot={messageCount.category.system > 0}>社区通知</Badge>
            </Menu.Item>
            <Menu.Item key="jobs_channel">
              <Badge dot={messageCount.category.jobs_channel > 0}>
                职位频道
              </Badge>
            </Menu.Item>
            <Menu.Item key="talent">
              <Badge dot={messageCount.category.talent > 0}>人才库通知</Badge>
            </Menu.Item>
          </Menu>

          {state.category !== "talent" && (
            <Alert
              message="仅显半年内的消息"
              type="info"
              showIcon
            />
          )}

          <SkeletonList
            data={!loading && messages}
            emptyDescription={renderEmptyDescription()}
          >
            {!loading && messages && messages.map(renderMessage)}
          </SkeletonList>

          <Pager
            pager={pager}
            onPageChange={handleFetch}
          />
        </Space>
      </Card>
    </SiteLayout>
  );
};

Page.requireUser = () => true;

const mapStateToProps = (state) => ({
  token: state.user.token,
  user: state.user.user,
  messageList: state.message.messageList,
  messageCount: state.message.messageCount,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMessageList,
      getMessageCount,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Page);
